import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux'
import API from '../../../utils/API';
import UserModal from './UserModal';
import RoleModal from './RoleModal';
import NotificationModal from '../../../components/SignagePlus/NotificationModal';
import ImportModal from './ImportModal';
import { useNavigate } from 'react-router-dom';
import tableCheckbox from '../../../components/Inputs/tableCheckbox';
import editIcon from '../../../assets/icons/table/edit.svg';
import trashIcon from '../../../assets/icons/table/trash.svg';
import deleteUser from '../../../assets/icons/message-manager/delete-user.svg';
import constants from '../../../utils/constants';
import commonMethods from '../../../utils/common-methods';
import { FormattedMessage, useIntl } from 'react-intl';
import useInfiniteScroll from '../../../components/common/useInfiniteScroll';
import MesTable from '../../../components/Table/MesTable';
import warn from '../../../assets/icons/message-manager/warn.svg';
import commonFunctions from '../../../utils/commonFunctions';
import SignageAssignSiteModal from './SignageAssignSiteModal';
import ToastNoSite from '../../../components/Toast/ToastNoSite';

function SignageUsers(props) {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission) => permission.id);

  if (!permissionIds.includes(constants.permissionIds.signagePlusEdit)) {
    navigate('/forbidden');
  }

  //Implemented multi-language support
  const intl = useIntl();
  const translation = (id) => intl.formatMessage({ id });

  const [selectedUser, setSelectedUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [modalError, setModalError] = useState('');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [actionType, setActionType] = useState('');

  const [usersData, setUsersData] = useState([]);
  const [data, setData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [selectedIds, setSelectedIds] = useState({});
  const [sortByCol, setSortByCol] = useState('');
  const [sortByAsc, setSortByAsc] = useState();
  const [startIndexForTable, setStartIndexForTable] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [notificationProps, setNotificationProps] = useState({
    icon: deleteUser,
    message: 'ARE_YOU_SURE',
    description: 'ARE_YOU_SURE_DESCRIPTION',
    showSecondaryButton: true,
    primaryButtonText: 'CONTINUE',
    className: 'red',
  });
  const [checkSites, setCheckSites] = useState(false);
  const [siteLength, setSiteLength] = useState(0);
  const tableRef = useRef();
  const tableWrapperRef = useRef();
  const modalRef = useRef(null);

  const loadTable = async (map, resetSelection = true) => {
    const oldMapData = map.data;
    map.data = {};
    map.ids = [];
    map.sortedIds = [];
    map.filteredIds = [];
    if (resetSelection) {
      map.selectedIds = {};
    }
    setCheckSites("");
    try {
      const res = await API.getSignageUsers();
      console.log('res', res.data);
      res.data.forEach((user) => {
        let resentState = false;
        if (oldMapData[user.id]) {
          resentState = oldMapData[user.id].resent;
        }

        let lastSeenDisplay;
        if (user.status === 0 || user.status === undefined || user.status === null) {
          lastSeenDisplay = resentState ? "Resend Invite" : "Resend Invite"; // Searchable string for 'Resend Invite'
        } else if (user.lastSeen === undefined || user.lastSeen === null) {
          lastSeenDisplay = "Never";
        } else if (new Date() - new Date(user.lastSeen) < 1000 * 60 * 6) {
          lastSeenDisplay = "Online";
        } else {
          lastSeenDisplay = commonMethods.timeSince(new Date(user.lastSeen));
        }
        const sitesDisplay = user.sites && Array.isArray(user.sites)
          ? user.sites.map((site) => site.name).join(', ').trim()
          : '';
        const hasRequiredRole = Array.isArray(user.roles) && user.roles.some(role =>
          [
            constants.RoleIDs.signageAdmin,
            constants.RoleIDs.signageOwner,
            constants.RoleIDs.signageTeacher
          ].includes(role.id)
        );
        if (hasRequiredRole && sitesDisplay === '')
          setCheckSites("FEATURE_ADMIN_NO_SITE");

        map.data[user.id] = {
          id: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          lastSeenDisplay,
          lastSeen: user.lastSeen,
          status: user.status,
          phone: user.phone,
          email: user.email,
          roles: user.roles,
          roleNames: /*user.roles*/(commonFunctions.getRolesSort(user.roles)).map((role) => role.id ? translation(`${role.id}-ROLENAME`) : "").join(', '),
          checked: false,
          resent: resentState,
          sites: user.sites,
          sitesDisplay,
        };
      });
      map.filteredIds = Object.keys(map.data);
      map.ids = Object.keys(map.data);
      setUsersData(res.data);
      setDataCount(map.ids.length);
      setSelectedIds(map.selectedIds);
      setTotalDataCount(map.ids.length);
      setDataLoaded(true);

      const rolesRes = await API.getRoles();
      rolesRes.data = rolesRes.data.filter(role => role.id === constants.RoleIDs.signageAdmin || role.id === constants.RoleIDs.signageOwner || role.id === constants.RoleIDs.signageTeacher);
      rolesRes.data.sort((a, b) => a.name.localeCompare(b.name));
      setRoles(rolesRes.data);
    } catch (err) {
      setDataLoaded(true);
      if (err.response?.data?.error) {
        return;
      }
      setError(err.message);
    }
  };

  const dataMap = React.useMemo(() => {
    const map = { data: {}, ids: [], selectedIds: {}, filteredIds: [] };
    loadTable(map);
    return map;
  }, []);

  useEffect(() => {
    modalRef.current = new window.bootstrap.Modal(document.getElementById('notificationModal'));
  }, []);

  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap,
    setData,
    setStartIndexForTable,
    startIndexForTable,
    pageSize: 100,
    sortByCol,
    setSortByCol,
    sortByAsc,
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
    rowHeight: 48,
  });

  // Hook for sorting data when data changes or sort column is changed
  useEffect(() => {
    if (dataLoaded) {
      if (searchValue !== '') {
        tableRef.current.search(dataMap);
      } else {
        sortMap(dataMap);
        setData(generateDataSlice(dataMap));
      }
    }
  }, [sortByCol, sortByAsc, dataLoaded, dataMap, usersData]);

  const handleEditClick = (e, id) => {
    e.preventDefault();
    let clickedUser = dataMap.data[id];
    setSelectedUser(clickedUser);
  };

  const handleSingleDelete = (e, id) => {
    e.preventDefault();
    let clickedUser = dataMap.data[id];
    setSelectedUser(clickedUser);
    setActionType('single');
  };

  const handleMassDelete = (e) => {
    e.preventDefault();
    setActionType('multiple');
  };

  useEffect(() => {
    setNotificationProps({
      icon: deleteUser,
      message: 'ARE_YOU_SURE',
      description: 'ARE_YOU_SURE_DESCRIPTION',
      showSecondaryButton: true,
      primaryButtonText: 'CONTINUE',
      className: 'red',
      onSubmit: () => {
        handleDeleteUsers();
        modalRef.current.hide();
      }
    });
  }, [actionType, selectedUser, selectedIds]);

  const handleDeleteUsers = async () => {
    setSuccess('');
    setError('');

    try {
      if (actionType === 'single') {
        //&& !selectedUser.roles.some((role) => role.id === constants.RoleIDs.accountOwner
        if (selectedUser ) {
          await API.deleteSignageUser(selectedUser.id);
          setSuccess(<FormattedMessage id="DELETE_USER_SUCCESS" />);
        } else {
          setError(<FormattedMessage id="DELETE_USER_FAILED" values={{ errorMsg: "" }}/>);
        }
      } else {
        const idsToDelete = Object.keys(selectedIds).filter((id) => selectedIds[id]);
        //   .map((id) => dataMap.data[id])
        //   .filter((user) => !user.roles.some((role) => role.id === constants.RoleIDs.accountOwner));

        // if (usersToDelete.length === 0) {
        //   setError(<FormattedMessage id="DELETE_USERS_FAILED" />);
        //   return;
        // }
        await Promise.all(idsToDelete.map((user) => API.deleteSignageUser(user)));

        setSuccess(<FormattedMessage id="COUNT_USERS_DELETED_SUCCESS" values={{ userCounts: idsToDelete.length }} />);
      }
      closeModal();
    } catch (err) {
      setError(<FormattedMessage id="DELETE_USERS_FAILED" values={{ errorMsg: <b>{err.message}</b> }} />);
    }

    loadTable(dataMap);
  };

  const resendVerification = async (e, row) => {
    e.preventDefault();
    dataMap.data[row.id].resent = true;
    loadTable(dataMap, false);
    setTimeout(() => {
      dataMap.data[row.id].resent = false;
      loadTable(dataMap, false);
    }, 10000);
    try {
      await API.resendUserVerification(row.email);
      setSuccess(<FormattedMessage id="RESENT_TO_EMAIL" values={{ email: <b>{row.email}</b> }} />);
    } catch (err) {
      setError(<FormattedMessage id="RESENT_TO_EMAIL_FAIL" values={{ email: <b>{row.email}</b> }} />);
    }
  };

  const handleShowModal = (id) => {
    const shouldShowModal = usersData.length > 0;
    if (shouldShowModal) {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      } else {
        console.error(`Modal element with id '${id}' not found`);
      }
    } else {
      setNotificationProps({
        icon: warn,
        message: 'MESSAGE_FAILED',
        description: 'USER_NOT_SITE',
        primaryButtonText: 'CANCEL',
        className: 'red',
        onSubmit: () => {
          modalRef.current.hide();
        }
      });
      modalRef.current.show();
    }
  }

  const resetUserModalRef = useRef(null);
  const handleResetUserModal = () => {
    if (resetUserModalRef.current) {
      resetUserModalRef.current();
    }
  };

  const resetRoleModalRef = useRef(null);
  const handleResetRoleModal = () => {
    if (resetRoleModalRef.current) {
      resetRoleModalRef.current();
    }
  };

  const resetImportModalRef = useRef(null);
  const handleResetImportModal = () => {
    if (resetImportModalRef.current) {
      resetImportModalRef.current();
    }
  };

  const closeModal = (modalId) => {
    if (!modalId) {
      modalRef.current.hide();
    } else {
      const modal = document.getElementById(modalId);
      if (modal) {
        const closeButton = modal.querySelector('.btn-close, [data-bs-dismiss="modal"]');
        if (closeButton) {
          closeButton.click();
        }
      }
    }
    // Reset modal states after closing the modal
    handleResetUserModal();
    handleResetRoleModal();
  };

  const tableColumnArray = [
    {
      Header: tableCheckbox,
      id: 'checkbox',
      accessor: 'checked',
      Cell: tableCheckbox,
      isVisible: true,
      width: 63,
      maxWidth: 63,
    },
    {
      Header: 'FIRST_NAME',
      id: 'firstName',
      accessor: 'firstName',
      isVisible: true,
    },
    {
      Header: 'LAST_NAME',
      id: 'lastName',
      accessor: 'lastName',
      isVisible: true,
    },
    {
      Header: 'EMAIL',
      id: 'email',
      accessor: 'email',
      isVisible: true,
    },
    {
      Header: 'LAST_SEEN',
      id: 'lastSeen',
      isVisible: true,
      accessor: 'lastSeenDisplay',
      Cell: ({ value, row }) => {
        const { status, resent, lastSeenDisplay } = row.original;
        if (status === 0 || status === undefined || status === null) {
          if (resent) {
            return <div style={{ color: 'gray', cursor: 'pointer' }}><FormattedMessage id="RESEND_INVITE" defaultMessage='Resend Invite'/></div>;
          }
          return <div onClick={(e) => resendVerification(e, row.original)} style={{ color: '#0070B9', cursor: 'pointer' }}><FormattedMessage id="RESEND_INVITE" defaultMessage='Resend Invite'/></div>;
        } else if (lastSeenDisplay === "Never") {
          return lastSeenDisplay;
        } else if (lastSeenDisplay === "Online") {
          return <div style={{ color: 'green' }}>{lastSeenDisplay}</div>;
        } else {
          return <div style={{ color: 'gray' }}>{lastSeenDisplay}</div>;
        }
      }
    },
    {
      Header: 'SITES',
      id: 'sites',
      dataIndex: 'sites',
      accessor: 'sitesDisplay',
      isVisible: true,
    },
    {
      Header: 'ROLES',
      id: 'roleNames',
      isVisible: true,
      accessor: 'roleNames',
    },
    {
      Header: '',
      id: 'actions',
      isVisible: true,
      Cell: ({ row }) => (
        <div className="actions">
          <button
            className="btn"
            id="editBtn"
            data-bs-toggle="modal"
            data-bs-target="#userModal"
            onClick={(e) => {
              e.stopPropagation(); // Prevent click from propagating to the parent cell
              if (handleEditClick) handleEditClick(e, row.original.id);
            }}
          >
            <img src={editIcon} className="actionIcon editAction" alt={<FormattedMessage id="EDIT" />} />
          </button>
          <button
            className="btn red"
            id="deleteBtns"
            data-bs-toggle="modal"
            data-bs-target="#notificationModal"
            onClick={(e) => {
              e.stopPropagation(); // Prevent click from propagating to the parent cell
              if (handleSingleDelete) handleSingleDelete(e, row.original.id);
            }}
          >
            <img src={trashIcon} className="actionIcon deleteAction" alt={<FormattedMessage id="DELETE" />} />
          </button>
        </div>
      ),
      width: 100,
    },
  ];

  const tableColumns = useMemo(() => tableColumnArray, []);

  const buttons = {
    toolbarRightButtons: (
      <>
        <button
          id="mesAddBtn"
          type="button"
          className="btn fw-normal btn-outline-secondary mesAddBtn"
          data-bs-toggle="modal"
          data-bs-target="#userModal"
          onClick={(e) => {
            if (siteLength === 0) {
              setError(<FormattedMessage id="NO_SITE_ASSOCIATED" />);
              return;
            }
            handleResetUserModal();
          }
          }
        >
          <span><FormattedMessage id="ADD_USER" defaultMessage="Add User" /></span>
        </button>
        <button
          id="importBtn"
          type="button"
          className="btn btn-primary but-darkblue fw-normal"
          data-bs-toggle="modal"
          data-bs-target="#signagePlusImportUsersModal"
          onClick={(e) => {
            if (siteLength === 0) {
              setError(<FormattedMessage id="NO_SITE_ASSOCIATED" />);
              return;
            }
            handleResetImportModal();
          }}
        >
          <FormattedMessage id="IMPORT_USERS" defaultMessage="Import Users" />
        </button>
      </>
    ),
    footerButtons: (
      <>
        <button
          id="setRolesBtn"
          type="button"
          className="btn"
          disabled={Object.keys(selectedIds).length === 0}
          onClick={() => {
            if (siteLength === 0) {
              setError(<FormattedMessage id="NO_SITE_ASSOCIATED" />);
              return;
            }
            const modal = new window.bootstrap.Modal(document.getElementById('setRolesModal'));
            modal.show();
          }}
        >
          <span><FormattedMessage id="SET_ROLES" defaultMessage="Set Roles" /></span>
        </button>
        <button
          id="assignSiteBtn"
          type="button"
          className="btn"
          disabled={Object.keys(selectedIds).length === 0}
          onClick={() => {
            if (siteLength === 0) {
              setError(<FormattedMessage id="NO_SITE_ASSOCIATED" />);
              return;
            }
            const modal = new window.bootstrap.Modal(document.getElementById('assignSiteModal'));
            modal.show();
          }}
        >
          <FormattedMessage id="ASSIGN_CMS_SITE" defaultMessage="Assign CMS/Site" />
        </button>
        <button
          id="deleteBtn"
          type="button"
          className="btn deleteBtn"
          data-bs-toggle="modal"
          data-bs-target="#notificationModal"
          disabled={Object.keys(selectedIds).length === 0}
          onClick={handleMassDelete}
        >
          <FormattedMessage id="DELETE" defaultMessage="Delete" />
        </button>
      </>
    ),
  }

  const tableProps = {
    // The tableKey is for task#20542.
    // Each table requires a unique key to prevent preferences from being overwritten.
    tableKey: "sbds_admin_users_table",
    pageType: constants.pageType.Users,
    modalId: 'userModal',
    columns: tableColumns,
    data,
    setData,
    dataMap,
    generateDataSlice,
    sortMap,
    dataCount,
    setDataCount,
    totalDataCount,
    setSortBy,
    sortByCol,
    sortByAsc,
    success,
    setSuccess,
    error,
    setError,
    startIndex: startIndexForTable,
    selectedIds,
    setSelectedIds,
    searchValue,
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
    handleEditClick,
    handleSingleDelete,
    buttons,
    checkSites
  };

  const userModalProps = {
    setResetUserModalRef: (resetFunc) => { resetUserModalRef.current = resetFunc; },
    user,
    success,
    error,
    setSuccess,
    closeModal,
    setError,
    selectedUser,
    setSelectedUser,
    loadTable,
    dataMap,
  };

  const roleModalProps = {
    setResetRoleModalRef: (resetFunc) => { resetRoleModalRef.current = resetFunc; },
    roles,
    dataMap,
    loadTable,
    setSuccess,
    modalError,
    setModalError,
    closeModal
  };

  const importModalProps = {
    setResetImportModalRef: (resetFunc) => { resetImportModalRef.current = resetFunc; },
    setSuccess,
    modalError,
    setModalError,
    ImportLoadData: () => loadTable(dataMap),
    closeModal,
  };
  const signageAssignSiteModalProps = {
    selectedUserIds: Object.keys(dataMap.selectedIds),
    setSuccess,
    setError,
    closeModal,
    loadTable,
    dataMap,
    setSiteLength
  };

  return (
    <>
      <UserModal {...userModalProps} />
      <NotificationModal {...notificationProps} />
      <ImportModal {...importModalProps} />
      <RoleModal {...roleModalProps} />
      <MesTable {...tableProps} />
      <SignageAssignSiteModal {...signageAssignSiteModalProps} />
      <ToastNoSite checkSites={checkSites} />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(SignageUsers)
